<template>
    <!--カテゴリ内で表示をフィルタする-->
    <div class="group-list relative bg-theme-lightgray w-300 h-auto">
        <ul class="px-5 pt-0 pb-40">
            <li class="border-solid border-b border-bd-gray text-txt-black text-sm font-bold flex flex-col hover:bg-theme-gray"
                v-for="item in state.items" :key="item.id">
                <router-link class="py-2 block relative" @click="handleClick"
                    :to="{ name: 'Group', query: { operationtype: 'group', webcat_view: item.webcat_view, cassette_id: item.cassette_id } }">{{
                        item.cassette_block_name }}<br><span class="leading-1 right-0 text-xs text-txt-gray font-normal">{{
        item.maker_name }}</span></router-link>

            </li>
        </ul>
    </div>
</template>

<script>
import { useRoute } from 'vue-router'
import { ref, watchEffect, reactive } from 'vue';
import axios from 'axios'
import { search_json } from '@/json.config.js';


export default {
    name: 'Categorylist',
    methods: {
        handleClick: function () {
            window.scroll({ top: 0, behavior: 'smooth' });
        }
    },
    setup() {
        const route = useRoute()
        const category_param = ref(route.query.webcat_view)

        let url = ref('')
        const category_item = ref([])

        const state = reactive({
            // num:null,
            data: null,
            items: null
            // rates:{},
            // result:computed(() => state.num * state.rates.JPY),
        })

        let category_name = ref('')
        watchEffect(() => {
            // const router = useRouter()
            category_param.value = route.query.webcat_view
            category_item.value = []

            switch (category_param.value) {
                case 'Outlet':
                    category_name.value = 'アウトレット'
                    break
                // case 'Prevention':
                //     category_name.value = '感染対策用品'
                //     break
                case 'Accessory':
                    category_name.value = 'アクセサリー'
                    break
                case 'Desk':
                    category_name.value = 'デスク・デスク周辺'
                    break
                case 'Table':
                    category_name.value = 'テーブル'
                    break
                case 'Chair':
                    category_name.value = 'チェア'
                    break
                case 'Lobby':
                    category_name.value = '応接・ロビー'
                    break
                case 'MeetingChair':
                    category_name.value = 'ミーティングチェア'
                    break
                case 'Partition':
                    category_name.value = 'パーティション'
                    break
                case 'Board':
                    category_name.value = 'ボード'
                    break
                case 'Storage':
                    category_name.value = '収納'
                    break
                case 'Counter':
                    category_name.value = 'カウンター'
                    break
                // case 'Emergency':
                //     category_name.value = '防災用品'
                //     break
                case 'Education':
                    category_name.value = '教育・保育施設'
                    break
                case 'Medical':
                    category_name.value = '医療・福祉施設'
                    break
                default:
                    category_name.value = ''
                    break
            }

            url = "https://666wcb198b.execute-api.ap-northeast-1.amazonaws.com/resource/query?operationtype=category&webcat_view=" + category_param.value;
            // console.log(url)

            // const search_json = "https://ichioshi-s3.s3.ap-northeast-1.amazonaws.com/json/search2023_so.json"
            async function getitems() {
                const all_data = await axios.get(search_json)
                // state.data = await axios.get(url)
                all_data.data.forEach(function (value) {
                    if (value.webcat_view === category_param.value) {
                        category_item.value.push(value)
                    }
                })
                state.items = []
                // for(var i=0;i < state.data.data.Items.length;i++){
                for (var i = 0; i < category_item.value.length; i++) {
                    var val = category_item.value[i];
                    const group_id = val.cassette_id.split("_")[0];//グループを格納する変数
                    // state.items = group_id;
                    // console.log(state.items[0]["group_id"]);
                    // if(state.items["group_id"] == group_id){
                    //     console.log("同じ項目です");
                    // }
                    const item_val = {
                        [group_id]: {
                            cassette_id: val.cassette_id.split("_")[0],
                            webcat_view: val.webcat_view,
                            cassette_block_name: val.cassette_block_name,
                            maker_name: val.maker_name,
                            // cassette_img01:"https://ichioshi-s3.s3.ap-northeast-1.amazonaws.com/img/500/" + val.cassette_img01,
                            // sold_out_block:val.sold_out_block,
                            // cassette_comment01:val.cassette_comment01,
                            // cassette_price_on:parseInt(val.cassette_price_on, 10),
                            // cassette_price_off:parseInt(val.cassette_price_off,10)
                            // cassette_price_on:val.cassette_price_on.split(".")[0].replace(/(\d)(?=(\d\d\d)+$)/g, "$1,"),
                            // cassette_price_off:val.cassette_price_off.replace(/(\d)(?=(\d\d\d)+$)/g, "$1,")
                        }
                    }
                    // console.log(item_val);
                    state.items = Object.assign(state.items, item_val);
                }
                state.items = Object.values(state.items);
                // console.dir(state.items);
            }
            getitems()
        })


        return {
            // products,
            category_param,
            category_name,
            watchEffect,
            state,
            url,
        }
    }
}

</script>